import React from "react";
import styled from "styled-components/macro";
import alongLogoAsset from "./along-logo.svg";
import alongBulbMintLogoAsset from "./along-logo-bulb-mint.svg";
import along2LogoAsset from "./along-logo-2.svg";

type AlongLogoVariant = "standard" | "bulb-mint" | "along-2";
interface AlongLogoProps {
  size?: "standard" | "large";
  variant?: AlongLogoVariant;
  className?: string;
}

const alongLogoAssetMap = {
  standard: alongLogoAsset,
  "bulb-mint": alongBulbMintLogoAsset,
  "along-2": along2LogoAsset,
};

const $img = styled.img<AlongLogoProps>`
  height: ${(props) => (props.size === "standard" ? "3.125rem" : "5rem")};
  @media screen and (${({ theme }) => theme.BreakpointTabletDown}) {
    height: ${(props) => (props.size === "standard" ? "2rem" : "3rem")};
  }
`;

export default function AlongLogo({
  size = "standard",
  variant = "standard",
  className,
}: AlongLogoProps) {
  return (
    <$img
      size={size}
      src={alongLogoAssetMap[variant]}
      alt="Along Logo"
      className={className}
    />
  );
}
